import { makeStyles } from '@material-ui/core'

export const useSignInStyle = makeStyles(theme => ({
  rootContainer: {
    paddingTop: theme.spacing(24),
    [theme.breakpoints.down('lg')]: {
      paddingTop: theme.spacing(12)
    }
  },
  title: {
    fontWeight: theme.typography.fontWeightMedium,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(1)
  },
  usernameField: {
    width: theme.spacing(80)
  },
  passwordField: {
    width: theme.spacing(80)
  },
  signInButton: {
    marginTop: theme.spacing(1),
    width: theme.spacing(80)
  }
}))
